var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-primary-500 px-2 py-1 text-white hover:bg-primary-700 transition duration-150 ease-in-out font-sans font-medium tracking-widest text-center",class:[_vm.css, _vm.classes]},[_vm._v(" "+_vm._s(_vm.label ? _vm.label : '')+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }